module.exports = "<div class=\"container\">\n  <div class=\"md-12\">\n    <h3>Discuss</h3>\n    <disqus [identifier]=\"pageId\"></disqus>\n  </div>\n</div>"